/*
 * edit_type:
 *   0  普通文本
 *   1  下拉框 (由  mode_names 生成)
 *   2  数字
 *   3  选择网络设备
 *   4  数组
 *   5  tick(时间戳)，单位长度0.1秒
 *   6  hidded
 */

const dj_category = [
  {
    type_: '1',
    name_: '端口组',
    name_id: 'dn_dt_1',
    help_width: 600,
    help_title: '',
    help_content:
      '<h3>外部多按键模块、电话机，或主板的多个输入、输出端口</h3><br/>\
  <p><li>工作模式<ul><li>外部模块：需要配置信号1(DA)端口和信号2(CK)端口<br/>\
    <ul>\
      <li>信号1(DA)端口: 结果端口</li>\
      <li>信号2(CK)端口: 触发端口</li>\
    </ul>\
    </li><br/>\
  <li>顺序按键：按顺序添加(勾选)主板端口，当这些端口按顺序触发时，端口组产生正确信号</li></br>\
  <li>顺序输出：输出端口列表中，按顺序添加主板输出端口，这些端口会依次亮起<br/>\
    <ul>\
      <li>启动端口: 每个端口点亮的时间(1=0.1秒)</li>\
      <li>停止端口: 每个端口熄灭的时间(1=0.1秒)</li>\
      <li>信号1(DA)端口: 端口是否熄灭控制 0 熄灭，1 不熄灭</li>\
      <li>信号2(CK)端口: 循环控制 0 循环，1不循环</li>\
    </ul>\
    </li></br>\
  <li>输入并联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>\
  <li>输入串联：输出端口列表中，添加主板输入端口；当这些端口任一个被触发时，端口组产生正确信号</li></br>\
  <li>无序按键：输出端口列表中，添加主板输入端口；当这些端口均被触发过后，端口组产生正确信号</li></br>\
  <li>循环按键：输出端口列表中，按顺序添加主板输入端口；当这些端口按顺序触发，端口组产生正确信号。不产生错误信号</li></br>\
  <li>按键计数：输出端口列表中，按顺序添加主板输入端口；输出端口列表中，填入每个端口应该按下的次数</br>\
    当这些端口按下指定次数后，端口组产生正确信号。</li></br>\
  <li>呼吸灯组：输出端口列表中，添加需要参与呼吸效果的端口；</br>\
    <ul>\
      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>\
      <li>停在最亮、最暗的时间</li>\
      <li>最大亮度：灯的最大亮度，1-100</li>\
    </ul></li></br>\
  <li>多卡顺序识别：判定依次感应的IC卡编号，符合顺序的过关</br>\
    <ul>\
      <li>呼吸速度：呼吸的速度，值越大呼吸越慢</li>\
      <li>停在最亮、最暗的时间</li>\
      <li>答案列表：依次添加需要刷的卡号</li>\
    </ul>\
  </li></br>\
  </li></p>',
    help_url: 'http://i.siva-tech.com/sopemc',
    proplist: [
      {
        disp_hint: '外部模块：多按键板、电话机。其他：主板上的端口',
        disp_hint_id: 'dh_dt_1_p1',
        disp_name: '工作模式',
        disp_name_id: 'dn_dt_1_p1',
        field_name: 'work_mode',
        default_value: 0,
        disp_width: 120,
        disp_mode: 1,
        edit_type: 1,
        mode_names: ['外接模块', '顺序按键', '顺序输出', '节拍输出',
        '输入并联', '输入串联', '无序按键', '循环按键', '按键计数',
        '节奏判定(敲门)','地鼠模式','记忆按键','呼吸灯组','多卡顺序识别',
        '旋转编码器','数字输入输出','输出端口跟随','限时按下判定'],
        mode_name_ids: ['mn_dt_1_p1'],
      },
      {
        disp_name: '网络模块',
        disp_name_id: 'dn_dt_1_p2',
        disp_hint_id: 'dh_dt_1_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '启动端口',
        disp_name_id: 'dn_dt_1_p3',
        disp_hint_id: 'dh_dt_1_p3',
        field_name: 'start_io',
        disp_hint: '未用可不填',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '停止端口',
        disp_name_id: 'dn_dt_1_p4',
        disp_hint_id: 'dh_dt_1_p4',
        field_name: 'stop_io',
        disp_hint: '未用可不填',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '结果端口(信号1)',
        disp_name_id: 'dn_dt_1_p5',
        disp_hint_id: 'dh_dt_1_p5',
        field_name: 'result_io',
        disp_hint: '外部模块时，信号1所接的主控板端口',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '触发端口(信号2)',
        disp_name_id: 'dn_dt_1_p6',
        field_name: 'ck_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '失败等待',
        disp_name_id: 'dn_dt_1_p7',
        field_name: 'fail_wait',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '输入端口列表',
        disp_name_id: 'dn_dt_1_p8',
        field_name: 'input_io_list',
        disp_width: 320,
        default_value: [0],
        edit_type: 4,
        disp_mode: 0,
        mode_names: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
          38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
          73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
          106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
        ],
        edit_caption_id: 'ec_dt_1_p8',
        edit_item_name_id: 'ei_dt_1_p8',
        edit_value_name_id: 'ev_dt_1_p8',
        mode_name_ids: ['mn_dt_1_p8'],
      },
      {
        disp_name: '输入端口数',
        disp_name_id: 'dn_dt_1_p9',
        field_name: 'input_io_count',
        default_value: 1,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '输出端口列表',
        disp_name_id: 'dn_dt_1_p10',
        field_name: 'output_io_list', // 数组 default_value: 'test31',
        disp_width: 320,
        default_value: [0],
        edit_type: 4,
        disp_mode: 0,
        mode_names: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
          38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
          73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
          106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128,
        ],
        edit_caption_id: 'ec_dt_1_p10',
        edit_item_name_id: 'ei_dt_1_p10',
        edit_value_name_id: 'ev_dt_1_p10',
        mode_name_ids: ['mn_dt_1_p10'],
      },
      {
        disp_name: '输出端口数',
        disp_name_id: 'dn_dt_1_p11',
        field_name: 'output_io_count',
        default_value: 1,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '失败音效',
        disp_name_id: 'dn_dt_1_p12',
        field_name: 'on_fail_ae',
        disp_hint: '失败时，自动播放的音效编号。0 不播放',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
        disp_hint_id: 'dh_dt_1_p12',
      },
      {
        disp_name: '成功音效',
        disp_name_id: 'dn_dt_1_p13',
        field_name: 'on_success_ae',
        disp_hint: '成功时，自动播放的音效编号。0 不播放',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
        disp_hint_id: 'dh_dt_1_p13',
      },
    ],
    help_content_id: 'hc_dt_1',
  },
  {
    type_: '2',
    name_: '网络设备',
    name_id: 'dn_dt_2',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>机顶盒、打印机等</h3><br/>\
  <p><li>搜寻模式<ul><li>自动发现：通过内部设备发现协议，可以自动发现主板所属主题的网络设备</li><br/>\
  <li>指定IP端口：配置网络设备的IP和端口</li>\
  </li></p>',
    help_url: 'http://i.siva-tech.com/30t3ru',
    proplist: [
      {
        disp_name: '搜寻模式',
        disp_name_id: 'dn_dt_2_p1',
        field_name: 'device_discover_mode',
        default_value: 0,
        disp_width: 160,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['自动发现', '指定IP和端口'],
        mode_name_ids: ['mn_dt_2_p1'],
      },
      {
        disp_name: '网络设备ID',
        disp_name_id: 'dn_dt_2_p2',
        field_name: 'device_net_id',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: 'IP地址',
        disp_name_id: 'dn_dt_2_p3',
        field_name: 'device_ip',
        default_value: '0.0.0.0',
        disp_width: 160,
        edit_type: 0,
        disp_mode: 0,
      },
      {
        disp_name: 'IP端口',
        disp_name_id: 'dn_dt_2_p4',
        field_name: 'device_port',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
    ],
    help_content_id: 'hc_dt_2',
  },
  {
    type_: '3',
    name_: '输入端口',
    name_id: 'dn_dt_3',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>主控板的单个输入端口</h3><br/>\
  <p><li>工作模式<ul><li>普通：端口有有效电平时触发</li><br/>\
  <li>按键按下：按键按下时，触发一次</li><br/>\
  <li>按键释放：按键释放时，触发一次</li><br/>\
  <li>触发计数：端口被触发指定次数时，触发一次</li><br/>\
  <li>按下持续时间：端口被持续触发指定的时长后，触发一次</li><br/>\
  <li>松开持续时间：端口持续未被触发指定的时长后，触发一次</li><br/>\
  <li>反向信号：端口没有有效电平时触发，一般用于检测输出电磁锁信号的机关</li><br/>\
  <li>流程复位：按键按下时，流程复位</li><br/>\
  </li></p>',
    help_url: 'http://i.siva-tech.com/phnabg',
    proplist: [
      {
        disp_name: '工作模式',
        disp_name_id: 'dn_dt_3_p1',
        field_name: 'mode',
        default_value: 0,
        disp_width: 100,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['普通', '按键按下', '按键释放', '触发计数', '触发计数(限时)', '按下持续时间', '松开持续时间', '间断按下持续时间', '反向信号', '流程复位','多卡识别','遥控接收'],
        mode_name_ids: ['mn_dt_3_p1'],
      },
      {
        disp_name: '端口号',
        disp_name_id: 'dn_dt_3_p2',
        field_name: 'device_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '网络模块',
        disp_name_id: 'dn_dt_3_p3',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 140,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '计数',
        disp_name_id: 'dn_dt_3_p4',
        field_name: 'count',
        default_value: 0,
        edit_type: 2,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '延时(秒)',
        disp_name_id: 'dn_dt_3_p5',
        field_name: 'interval',
        default_value: 0,
        edit_type: 5,
        disp_width: 140,
        disp_mode: 0,
      },
    ],
    help_content_id: 'hc_dt_3',
  },
  {
    type_: '4',
    name_: '输出端口',
    name_id: 'dn_dt_4',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>主控板的单个输出端口</h3><br/>\
  <p><li>工作模式<ul><li>普通：开 继电器导通，关 继电器断开</li><br/>\
  <li>循环：启动后，继电器工作指定的次数。每个循环中，导通和断开时间通过<br/>“开启时长”和“关闭时长”配置，次数由“计数”配置<br/>\
  执行完成后，结束的状态可以是开(继电器导通)或关(继电器断开)，由“结束状态”配置</li><br/>\
  <li>预设亮度：仅V5硬件有效，开 按照预设值输出PWM，关 彻底断开</li><br/>\
  <li>渐亮渐灭：仅V5硬件有效，开 从0开始逐步增加至预设值，变化时长由“开启时长”控制<br/>关 从预设值逐步减小至彻底断开。变化时长由“关闭时长”控制</li><br/>\
  <li>随机闪烁：仅V5硬件PWM板有效，开 随机亮度变化，变化快慢由“开启时长”控制，熄灭时长由“关闭时长”控制<br/>关 立即熄灭</li><br/>\
  <li>呼吸效果：仅V5硬件PWM板有效，开 均匀亮度变化，变化快慢由“开启时长”控制<br/>关 立即熄灭</li><br/>\
  <li>状态跟随：开 跟随输入端口的状态，输入端口号由“计数”指定<br/>关 停止跟随状态</li><br/>\
  </li></p>',
    help_url:'http://i.siva-tech.com/uad3pk',
    proplist: [
      {
        disp_name: '工作模式',
        disp_name_id: 'dn_dt_4_p1',
        field_name: 'mode',
        default_value: 0,
        disp_width: 160,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['普通', '循环', '随机循环', '预设亮度', '渐亮渐灭', '随机闪烁', '呼吸效果','保留','状态跟随'],
        mode_name_ids: ['mn_dt_4_p1'],
      },
      {
        disp_name: '端口号',
        disp_name_id: 'dn_dt_4_p2',
        field_name: 'device_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '网络模块',
        disp_name_id: 'dn_dt_4_p3',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '计数',
        disp_name_id: 'dn_dt_4_p4',
        field_name: 'count',
        default_value: 0,
        edit_type: 2,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '亮度(低)',
        disp_name_id: 'dn_dt_4_p5',
        field_name: 'brightness_low',
        default_value: 0,
        disp_width: 120,
        edit_type: 7,
        disp_mode: 2,
      },
      {
        disp_name: '亮度(高)',
        disp_name_id: 'dn_dt_4_p6',
        field_name: 'brightness',
        default_value: 100,
        disp_width: 120,
        edit_type: 7,
        disp_mode: 2,
      },
      {
        disp_name: '毫秒级控制',
        disp_name_id: 'dn_dt_4_p7',
        field_name: 'msCtrl',
        default_value: 0,
        disp_width: 120,
        edit_type: 8,
        disp_mode: 0,
      },
      {
        disp_name: '开启时长',
        disp_name_id: 'dn_dt_4_p8',
        field_name: 'interval1',
        default_value: 0,
        edit_type: 5,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '关闭时长',
        disp_name_id: 'dn_dt_4_p9',
        field_name: 'interval2',
        default_value: 0,
        edit_type: 5,
        disp_width: 120,
        disp_mode: 0,
      },
      {
        disp_name: '结束状态',
        disp_name_id: 'dn_dt_4_p10',
        field_name: 'finish_status',
        default_value: 0,
        disp_width: 100,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['关', '开'],
        mode_name_ids: ['mn_dt_4_p2'],
      },
    ],
    help_content_id: 'hc_dt_4',
  },
  {
    type_: '5',
    name_: '输出-门/锁',
    name_id: 'dn_dt_5',
    help_width: 600,
    help_title: '',
    help_content:
      '<h3>各种类型的门</h3><br/>\
  <p><li>工作模式<ul><li>电磁锁(常开)：电磁锁接在常开端，由“开门端口”控制。关门状态 端口继电器导通</li><br/>\
  <li>闭门器：由“开门端口”控制。关门状态 端口继电器导通</li><br/>\
  <li>推杆电机：由“开门端口”和“关门端口”控制。\
    <br/>关门状态 关门端口继电器导通“关延时”秒(如果延时为0，一直保持导通)\
    <br/>开门状态 开门端口继电器导通“开延时”秒(如果延时为0，一直保持导通)</li><br/>\
  <li>电磁锁(常闭)：电磁锁接在常闭端，由“开门端口”控制。关门状态 端口继电器断开</li><br/>\
  <li>闭门器带电磁锁：闭门器由“开门端口”控制。关门状态 端口继电器断开<br/>\
  电磁锁 由“关门端口”控制。关门状态 端口继电器导通</li><br/>\
  </li></p>',
    help_url: 'http://i.siva-tech.com/fcmlxf',
    proplist: [
      {
        disp_name: '工作模式',
        disp_name_id: 'dn_dt_5_p1',
        field_name: 'door_type',
        default_value: 1,
        disp_width: 160,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['未定义', '电磁锁(接常开)', '闭门器(常开)', '推杆电机', '电磁锁(接常闭)', '闭门器(常闭)', '闭门器带电磁锁'],
        mode_name_ids: ['mn_dt_5_p1'],
      },
      {
        disp_name: '网络模块',
        disp_name_id: 'dn_dt_5_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '开门端口',
        disp_name_id: 'dn_dt_5_p3',
        field_name: 'open_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '关门端口',
        disp_name_id: 'dn_dt_5_p4',
        field_name: 'close_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '行程时间(秒)',
        disp_name_id: 'dn_dt_5_p5',
        field_name: 'interval',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
    ],
    help_content_id: 'hc_dt_5',
  },
  {
    type_: '7',
    name_: '输出-灯',
    name_id: 'dn_dt_7',
    help_width: 500,
    help_title: '',
    help_content: '<h3>灯设备</h3><br/>\
  <p><li>端口号<ul><li>灯的供电由“端口”控制。灯点亮时，对应端口的继电器导通</li><br/>\
  </li></p>',
    proplist: [
      {
        disp_name: '端口',
        disp_name_id: 'dn_dt_7_p1',
        field_name: 'device_io',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '亮度',
        disp_name_id: 'dn_dt_7_p2',
        field_name: 'brightness',
        default_value: 100,
        disp_width: 100,
        edit_type: 7,
        disp_mode: 2,
      },
    ],
    help_content_id: 'hc_dt_7',
  },
  {
    type_: '8',
    name_: '音效',
    name_id: 'dn_dt_8',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>音效</h3><br/>\
  <span>音效支持本地模式(U盘或TF卡)和网络模式(通过音效机顶盒)</span>\
  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>\
  如001.mp3,002.mp3</li><br/>\
  </li></p>\
  <p><li>机顶盒编号<ul><li>用于指定播放本音效的机顶盒。</li><br/>\
  </li></p>',
    help_url:'http://i.siva-tech.com/ugevqx',
    proplist: [
      {
        disp_name: '文件编号',
        disp_name_id: 'dn_dt_8_p1',
        field_name: 'file_index',
        default_value: 1,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_8_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '播放音量',
        disp_name_id: 'dn_dt_8_p3',
        field_name: 'volume',
        default_value: 120,
        disp_width: 160,
        edit_type: 6,
        disp_mode: 2,
      },
    ],
    help_content_id: 'hc_dt_8',
  },
  {
    type_: '9',
    name_: '超时音效',
    name_id: 'dn_dt_9',
    help_width: 500,
    help_title: '',
    help_content: '',
    proplist: [
      {
        disp_name: '文件编号',
        disp_name_id: 'dn_dt_9_p1',
        field_name: 'file_index',
        default_value: 1,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_9_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '播放音量',
        disp_name_id: 'dn_dt_9_p3',
        field_name: 'volume',
        default_value: 120,
        disp_width: 160,
        edit_type: 6,
        disp_mode: 2,
      },
    ],
  },
  {
    type_: '10',
    name_: '背景音',
    name_id: 'dn_dt_10',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>背景音</h3><br/>\
  <span>背景音开始播放后进入循环播放模式，支持本地模式(U盘或TF卡)<br/>和网络模式(通过音效机顶盒)</span>\
  <p><li>文件编号<ul><li>音效对应的文件编号，文件在U盘或服务器上以编号.mp3命名。<br/>\
  如001.mp3,002.mp3</li><br/>\
  </li></p>\
  ',
    help_url:'http://i.siva-tech.com/ugevqx',
    proplist: [
      {
        disp_name: '文件编号',
        disp_name_id: 'dn_dt_10_p1',
        field_name: 'file_index',
        default_value: 1,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_10_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
      {
        disp_name: '播放音量',
        disp_name_id: 'dn_dt_10_p3',
        field_name: 'volume',
        default_value: 120,
        disp_width: 100,
        edit_type: 6,
        disp_mode: 2,
      },
    ],
    help_content_id: 'hc_dt_10',
  },
  {
    type_: '11',
    name_: '视频',
    name_id: 'dn_dt_11',
    help_width: 500,
    help_title: '',
    help_content:
      '<h3>视频</h3><br/>\
  <span>视频支持本地模式(播放位于机顶盒上的U盘中的视频文件)<br/>\
  和网络模式(播放门店服务器中的视频文件)</span>\
    <li>文件编号: 本地模式下，在U盘里的视频对应的文件编号。文件以<br/>\
        编号.mp4命名。如001.mp4,002.mp4</li>\
    <li>播放协议\
    <ul><li>常规： 播放普通的视频文件</li>\
    <li>实时监控： 播放局域网下监控摄像头的实时画面</li>\
    </ul></li>\
  <li>机顶盒编号: 用于指定播放本段视频的机顶盒。</li>\
  <li>视频长度: 播放文件时，用于指定需要播放的时长(应小于文件本身的时长)。</li>\
  <li>播放地址: 网络模式下，在服务器的视频路径。如完整路径为：<br/>http://192.168.1.100/HYZG/videos/001.mp4\
  此处应填写001.mp4</li>\
  ',
    help_url:'http://i.siva-tech.com/68isko',
    proplist: [
      {
        disp_name: '文件编号',
        disp_name_id: 'dn_dt_11_p1',
        field_name: 'file_index',
        default_value: 0,
        edit_type: 2,
        disp_hint: '存放在机顶盒U盘上的文件名(编号部分)',
        disp_hint_id: 'dh_dt_11_p1',
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '播放协议',
        disp_name_id: 'dn_dt_11_p2',
        field_name: 'protocol',
        default_value: 0,
        disp_width: 160,
        edit_type: 1,
        disp_mode: 1,
        mode_names: ['常规(FILE/HTTP)', '实时监控'],
        mode_name_ids: ['dn_dt_11_p2_p1'],
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_11_p3',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 0,
      },
      {
        disp_name: '视频长度(秒)',
        disp_name_id: 'dn_dt_11_p4',
        field_name: 'video_duration',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 0,
      },
      {
        disp_name: '播放地址(文件名)',
        disp_name_id: 'dn_dt_11_p5',
        field_name: 'device_url',
        default_value: '001.mp4',
        disp_width: 480,
        disp_hint: '存放在服务器上的文件名',
        disp_hint_id: 'dh_dt_11_p2',
        disp_mode: 0,
        edit_type: 0,
      },
      {
        disp_name: '播放音量',
        disp_name_id: 'dn_dt_11_p6',
        field_name: 'volume',
        default_value: 100,
        disp_width: 160,
        edit_type: 6,
        disp_mode: 2,
      },
    ],
    help_content_id: 'hc_dt_11',
  },
  {
    type_: '12',
    name_: '图片',
    name_id: 'dn_dt_12',
    help_width: 500,
    help_title: '',
    help_content: '',
    proplist: [
      {
        disp_name: '图片文件编号',
        disp_name_id: 'dn_dt_12_p1',
        field_name: 'file_index',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_12_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 0,
      },
      {
        disp_name: '播放地址(文件名)',
        disp_name_id: 'dn_dt_12_p3',
        field_name: 'device_url',
        default_value: '001.jpg',
        disp_width: 480,
        disp_hint: '存放在U盘上的文件名',
        disp_hint_id: 'dh_dt_12_p1',
        disp_mode: 0,
        edit_type: 0,
      },
    ],
  },
  {
    type_: '13',
    name_: '网络互动',
    name_id: 'dn_dt_13',
    help_width: 500,
    help_title: '',
    help_content: '',
    help_url:'http://i.siva-tech.com/gw0g89',
    proplist: [
      {
        disp_name: '互动环节编号',
        disp_name_id: 'dn_dt_13_p1',
        field_name: 'file_index',
        default_value: 0,
        edit_type: 2,
        disp_width: 160,
        disp_mode: 2,
      },
      {
        disp_name: '机顶盒编号',
        disp_name_id: 'dn_dt_13_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 0,
      },
    ],
  },
  {
    type_: '14',
    name_: '计数器',
    name_id: 'dn_dt_14',
    help_width: 500,
    help_title: '',
    help_content: '<h3>计数器</h3><br/>\
  <p><li>存放数值，可以用于数值计算和判定<br/></li></p>\
  <p><li>秒级计时器，可以用于秒级的计时<br/></li></p>',
    help_url:'http://i.siva-tech.com/mw2rmi',
    proplist: [
      {
        disp_name: '工作模式',
        disp_name_id: 'dn_dt_14_p1',
        field_name: 'mode',
        mode_names: ['数值','计时器'],
        mode_name_ids: ['mn_dt_14_p1'],
        default_value: 0,
        disp_mode: 1,
        edit_type: 1,
        disp_width: 160,
      },
      {
        disp_name: '网络模块',
        disp_name_id: 'dn_dt_14_p2',
        field_name: 'netdev_id',
        default_value: 0,
        disp_width: 160,
        edit_type: 3,
        disp_mode: 2,
      },
    ],
    help_content_id: 'hc_dt_14',
  },
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  {
    type_: '30',
    name_: '任务',
    name_id: 'dn_dt_30',
  },
  {
    type_: '31',
    name_: '始终执行',
    name_id: 'dn_dt_31',
  },
  {
    type_: '32',
    name_: '跳关',
    name_id: 'dn_dt_32',
  },
  {
    type_: '33',
    name_: '网络设备就绪',
    name_id: 'dn_dt_33',
  },
  {
    type_: '34',
    name_: '房间收拾完成',
    name_id: 'dn_dt_34',
  },
  {
    type_: '35',
    name_: '主题开始',
    name_id: 'dn_dt_35',
  },
  {
    type_: '36',
    name_: '主题通关',
    name_id: 'dn_dt_36',
  },
  {
    type_: '39',
    name_: '场景效果',
    name_id: 'dn_dt_39',
  },
  {
    type_: '40',
    name_: '语言设置',
    name_id: 'dn_dt_40',
  },
]

export function getDjCategory() {
  return dj_category
}
